import { Component, computed, inject, input, output, ChangeDetectionStrategy } from '@angular/core';
import { menuContents } from '../menu-contents';
import { RouterModule } from '@angular/router';
import { ApplicationContextStore, AuthService, ThemeService } from '@raptor-fe/services';
import { filterVisibleMenuItems, SubmenuToggleState } from '@raptor-fe/ui';

@Component({
    selector: 'marlin-web-header',
    imports: [RouterModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true,
    providers: [SubmenuToggleState],
})
export class HeaderComponent {
    authService = inject(AuthService);
    private readonly applicationContextStore = inject(ApplicationContextStore);
    protected readonly currentLogoUrl = inject(ThemeService).currentLogoUrl;
    protected readonly submenus = inject(SubmenuToggleState);

    public menuItems = menuContents;
    toggleTheme = output<null>();
    isDarkTheme = input<boolean>(false);

    /**
     * The menu tree filtered to the entries the current user may see. Gating is applied at every
     * level by the shared predicate (feature flags AND `viewPermission`), and a container whose
     * children are all gated away is dropped so the dropdown never renders an empty group.
     */
    protected readonly visibleMenuItems = computed(() =>
        filterVisibleMenuItems(this.menuItems, (key) => this.applicationContextStore.hasPermission(key), this.applicationContextStore.features()),
    );
}
